export default {"src":"/_next/static/media/edit.46c2d0f8.svg","height":15,"width":15};